<template>
  <div>
    <loading :active.sync="loader" :can-cancel="false" :is-full-page="true" />
    <b-modal v-model="modalVisible" size="md" hide-header hide-footer>
      <b-row class="align-items-center">
        <b-col class="text-left pt-3 pb-3">
          <h1 class="titulo-modal">EDITAR horario clínica</h1>
        </b-col>
        <b-col cols="2" class="text-right">
          <b-button variant="link" class="btn-cerrar-modal" @click="cerrarModal">
            <span class="cerrar-icon">&times;</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          <span class="mr-4"><strong>Región:</strong> {{ nombreZona }}</span>
          <span><strong>Clínica:</strong> {{ nombreClinica }}</span>
        </b-col>
      </b-row>

      <h2 class="subtitulo-modal mb-3">Horarios de atención</h2>

      <b-row class="mb-2">
        <b-col class="d-flex align-items-center">
          <input
              type="radio"
              id="radio-mismo"
              :value="true"
              v-model="usarMismoHorario"
              class="mr-2 radio-cuadrado"
          >
          <label for="radio-mismo" class="mb-0 checkbox-label">Usar mismo horario para todos los días</label>
        </b-col>
      </b-row>

      <b-row class="mb-4 pl-4">
        <b-col cols="6">
          <TimepickerField
              id="timepicker-apertura-gral"
              label="Apertura General"
              v-model="horarioApertura"
              :disabled="!usarMismoHorario"
          />
        </b-col>
        <b-col cols="6">
          <TimepickerField
              id="timepicker-cierre-gral"
              label="Cierre General"
              v-model="horarioCierre"
              :disabled="!usarMismoHorario"
          />
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col cols="12" class="d-flex align-items-center">
          <input
              type="radio"
              id="radio-dia"
              :value="false"
              v-model="usarMismoHorario"
              class="mr-2 radio-cuadrado"
          >
          <label for="radio-dia" class="mb-0 checkbox-label">Configurar por día</label>
        </b-col>
      </b-row>

      <div class="mt-3" :class="{ 'seccion-desactivada': usarMismoHorario }">
        <b-row class="text-muted small font-weight-bold mb-2 text-center no-gutters">
          <b-col cols="1">DÍA</b-col>
          <b-col cols="4">APERTURA</b-col>
          <b-col cols="4">CIERRE</b-col>
          <b-col cols="3">SIN OPERACIÓN</b-col>
        </b-row>

        <HorarioDiaRow
            v-for="dia in listaDias"
            :key="dia.idDia"
            :dia="dia"
            :disabled="usarMismoHorario"
            @update:apertura="$set(dia, 'apertura', $event)"
            @update:cierre="$set(dia, 'cierre', $event)"
            @update:sinOperacion="onSinOperacionChange(dia, $event)"
        />
      </div>

      <b-row class="mt-4">
        <b-col class="d-flex justify-content-center">
          <b-button variant="primary" class="btn-guardar mr-3 rounded-pill" @click="guardarHorarios">Guardar</b-button>
          <b-button variant="secondary" class="btn-cancelar rounded-pill" @click="cerrarModal">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import HorarioDiaRow from './HorarioDiaRow.vue';
import TimepickerField from './TimepickerField.vue';

export default {
  components: {
    HorarioDiaRow,
    TimepickerField
  },
  data() {
    return {
      modalVisible: false,
      idClinica: null,
      nombreClinica: '',
      nombreZona: '',
      usarMismoHorario: false,
      horarioApertura: { HH: '00', mm: '00' },
      horarioCierre: { HH: '23', mm: '59' },
      listaDias: [],
      loader: false,
    }
  },

  watch: {
    usarMismoHorario(nuevoValor) {
      if (nuevoValor) {
        this.aplicarHorarioATodos();
      }
    },
    horarioGeneral: {
      handler() {
        if (this.usarMismoHorario) {
          this.replicarHorarioGeneral();
        }
      },
      deep: true
    }
  },

  computed: {
    horarioGeneral() {
      return {
        apertura: { ...this.horarioApertura },
        cierre: { ...this.horarioCierre }
      };
    }
  },

  methods: {
    /**
     * Maneja el cambio del switch sinOperacion de un día.
     * @param {Object} dia - Objeto del día
     * @param {boolean} valor - Nuevo valor de sinOperacion
     */
    onSinOperacionChange(dia, valor) {
      this.$set(dia, 'sinOperacion', valor);
      if (valor) {
        this.$set(dia, 'apertura', { HH: '', mm: '' });
        this.$set(dia, 'cierre', { HH: '', mm: '' });
      } else {
        this.$set(dia, 'apertura', { HH: '00', mm: '00' });
        this.$set(dia, 'cierre', { HH: '23', mm: '59' });
      }
    },
    /**
     * Consulta los datos de la clínica desde la API.
     * @param {number} idClinica - ID de la clínica
     */
    async cargarDatosClinica(idClinica) {
      this.loader = true;
      try {
        const response = await this.$http.post(this.$api + 'horarioCLinica/clinica', { idClinica: idClinica} );
        if (response.data.data == null) {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Error al cargar los datos. No se encontraron horarios para esta clínica, inténtalo más tarde',
            returnFocus: false
          });
        }
        return response.data.data;
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.mensaje || 'Error al cargar los datos de la clínica',
          returnFocus: false
        });
        return null;
      } finally {
        this.loader = false;
      }
    },

    /**
     * Convierte enteros del backend (ej: 900, 1430) a formato de timepicker.
     * Usado por: abrirModal
     */
    parseHora(valor) {
      if (valor === null || valor === undefined) {
        return { HH: '00', mm: '00' };
      }

      const str = valor.toString().trim();

      if (str.includes(':')) {
        const [HH, mm] = str.split(':');
        return {
          HH: HH.padStart(2, '0'),
          mm: (mm || '00').padStart(2, '0')
        };
      }

      const padded = str.padStart(4, '0');
      return {
        HH: padded.substring(0, 2),
        mm: padded.substring(2, 4)
      };
    },

    /**
     * Convierte formato timepicker a entero para el backend.
     * Ejemplo: { HH: '10', mm: '00' } → 600
     * Usado por: guardarHorarios
     */
    formatHoraToInteger(hora) {
      if (!hora || !hora.HH || !hora.mm || hora.HH === '' || hora.mm === '') return 0;

      const horas = Number.parseInt(hora.HH, 10);
      const minutos = Number.parseInt(hora.mm, 10);

      if (Number.isNaN(horas) || Number.isNaN(minutos)) return 0;

      return horas * 100 + minutos;
    },

    /**
     * Inicializa el modal consultando los datos de la clínica desde la API.
     * @param {number} idClinica - ID de la clínica a consultar
     */
    async abrirModal(idClinica) {
      if (!idClinica) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Falta el ID de la clínica',
          returnFocus: false
        });
        return;
      }

      const datosDTO = await this.cargarDatosClinica(idClinica);

      if (!datosDTO) {
        return;
      }

      this.idClinica = datosDTO.idClinica;
      this.nombreClinica = datosDTO.nombreClinica || '';
      this.nombreZona = datosDTO.nombreZona || '';
      this.usarMismoHorario = false;

      const listaHorarios = datosDTO.listaHorariosClinicaDia || [];

      // Estructura fija de días en orden: D, L, M, M, J, V, S
      const diasFijos = [
        { idDia: 7, inicial: 'D', nombre: 'Domingo' },
        { idDia: 1, inicial: 'L', nombre: 'Lunes' },
        { idDia: 2, inicial: 'M', nombre: 'Martes' },
        { idDia: 3, inicial: 'M', nombre: 'Miércoles' },
        { idDia: 4, inicial: 'J', nombre: 'Jueves' },
        { idDia: 5, inicial: 'V', nombre: 'Viernes' },
        { idDia: 6, inicial: 'S', nombre: 'Sábado' }
      ];

      // Crear mapa de horarios del backend por idDia para búsqueda rápida
      const horariosPorId = {};
      listaHorarios.forEach(horarioDia => {
        horariosPorId[horarioDia.idDia] = horarioDia;
      });

      // Mapear días fijos con datos del backend o defaults
      this.listaDias = diasFijos.map(diaFijo => {
        const horarioDia = horariosPorId[diaFijo.idDia];
        // Si no viene del backend, marcar como sin operación
        const sinOperacion = !horarioDia || horarioDia.sinOperacion;

        return {
          idDia: diaFijo.idDia,
          idDHorarioClinica: horarioDia?.idDHorarioClinica || null,
          nombre: diaFijo.nombre,
          inicial: diaFijo.inicial,
          apertura: sinOperacion ? { HH: '', mm: '' } : this.parseHora(horarioDia?.horaInicio),
          cierre: sinOperacion ? { HH: '', mm: '' } : this.parseHora(horarioDia?.horaCierre),
          sinOperacion
        };
      });

      this.modalVisible = true;
    },

    /**
     * Aplica el horario general a todos los días y resetea sinOperacion.
     * Activado por: watch de usarMismoHorario cuando cambia a true.
     */
    aplicarHorarioATodos() {
      this.listaDias.forEach(dia => {
        if (dia) {
          this.$set(dia, 'sinOperacion', false);
          this.$set(dia, 'apertura', { ...this.horarioApertura });
          this.$set(dia, 'cierre', { ...this.horarioCierre });
        }
      });
    },

    /**
     * Copia los horarios generales a todos los días.
     * Activado por: watch de horarioGeneral cuando usarMismoHorario === true.
     */
    replicarHorarioGeneral() {
      this.listaDias.forEach(dia => {
        if (dia) {
          this.$set(dia, 'apertura', { ...this.horarioApertura });
          this.$set(dia, 'cierre', { ...this.horarioCierre });
        }
      });
    },

    /**
     * Cierra el modal y limpia estado.
     */
    cerrarModal() {
      this.modalVisible = false;
      this.limpiarDatos();
    },

    /**
     * Resetea los campos del modal a sus valores iniciales.
     */
    limpiarDatos() {
      this.idClinica = null;
      this.nombreClinica = '';
      this.nombreZona = '';
      this.usarMismoHorario = false;
      this.horarioApertura = { HH: '00', mm: '00' };
      this.horarioCierre = { HH: '23', mm: '59' };
      this.listaDias = [];
    },

    /**
     * Valida que apertura sea menor que cierre.
     * Convierte horas a minutos para comparar.
     * Usado por: guardarHorarios
     */
    horarioEsValido(apertura, cierre) {
      if (!apertura || !cierre || !apertura.HH || !apertura.mm || !cierre.HH || !cierre.mm ||
          apertura.HH === '' || apertura.mm === '' || cierre.HH === '' || cierre.mm === '') {
        return false;
      }
      const aperturaMins = Number.parseInt(apertura.HH, 10) * 60 + Number.parseInt(apertura.mm, 10);
      const cierreMins = Number.parseInt(cierre.HH, 10) * 60 + Number.parseInt(cierre.mm, 10);
      return aperturaMins < cierreMins;
    },

    /**
     * Verifica si los horarios de los días son diferentes entre sí.
     * Retorna true si hay al menos un día con horario distinto.
     */
    horariosSonDiferentes() {
      if (this.listaDias.length === 0) return false;

      const diasConHorario = this.listaDias.filter(dia =>
        !dia.sinOperacion &&
        dia.apertura && dia.cierre &&
        dia.apertura.HH && dia.apertura.mm &&
        dia.cierre.HH && dia.cierre.mm &&
        dia.apertura.HH !== '' && dia.apertura.mm !== '' &&
        dia.cierre.HH !== '' && dia.cierre.mm !== ''
      );

      if (diasConHorario.length === 0) return false;

      const primerDia = diasConHorario[0];
      const aperturaRef = `${primerDia.apertura.HH}:${primerDia.apertura.mm}`;
      const cierreRef = `${primerDia.cierre.HH}:${primerDia.cierre.mm}`;

      return diasConHorario.some(dia => {
        const aperturaDia = `${dia.apertura.HH}:${dia.apertura.mm}`;
        const cierreDia = `${dia.cierre.HH}:${dia.cierre.mm}`;
        return aperturaDia !== aperturaRef || cierreDia !== cierreRef;
      });
    },

    /**
     * Muestra alerta de error de validación de horarios.
     */
    mostrarErrorHorarioInvalido() {
      this.$swal({
        icon: 'error',
        title: 'Horario inválido',
        text: 'La hora de apertura debe ser menor a la hora de cierre',
        returnFocus: false
      });
    },

    /**
     * Valida horarios y emite datos al componente padre.
     * - Si hay error, muestra sweetalert y NO guarda.
     * - Si está ok, emite 'guardar' con modo y dias.
     */
    async guardarHorarios() {
      if (this.usarMismoHorario) {
        if (!this.horarioEsValido(this.horarioApertura, this.horarioCierre)) {
          this.mostrarErrorHorarioInvalido();
          return;
        }
      } else {
        const diaInvalido = this.listaDias.find(
            dia => !dia.sinOperacion && !this.horarioEsValido(dia.apertura, dia.cierre)
        );

        if (diaInvalido) {
          this.mostrarErrorHorarioInvalido();
          return;
        }
      }

      const diasSinOperacion = this.listaDias.filter(dia => dia.sinOperacion);

      if (diasSinOperacion.length > 0) {
        const confirmado = await this.mostrarConfirmacionSinOperacion(diasSinOperacion);
        if (!confirmado) {
          return;
        }
      }

      const horariosGuardar = this.listaDias.map(dia => ({
        idClinica: this.idClinica,
        idDia: dia.idDia,
        idDHorarioClinica: dia.idDHorarioClinica,
        horaInicio: dia.sinOperacion ? 0 : this.formatHoraToInteger(dia.apertura),
        horaCierre: dia.sinOperacion ? 0 : this.formatHoraToInteger(dia.cierre),
        sinOperacion: dia.sinOperacion || false
      }));

      this.$emit('guardar', horariosGuardar, this.horariosSonDiferentes());
    },

    /**
     * Muestra confirmación cuando hay días sin operación.
     * @param {Array} diasSinOperacion - Lista de días marcados como sin operación
     * @returns {Promise<boolean>} - true si el usuario confirma
     */ async mostrarConfirmacionSinOperacion(diasSinOperacion) {
      return await new Promise((resolve) => {
        let mensaje;

        if (diasSinOperacion.length === this.listaDias.length) {
          mensaje = `La clínica <strong>${this.nombreClinica}</strong> NO TIENE OPERACIÓN actualmente`;
        } else {
          const nombresDias = diasSinOperacion.map(dia => dia.nombre.toUpperCase());

          if (nombresDias.length === 1) {
            mensaje = `El día <strong>${nombresDias[0]}</strong> no va a tener operación en clínica`;
          } else {
            const ultimo = nombresDias[nombresDias.length - 1];
            const listaAnteriores = nombresDias.slice(0, -1);
            mensaje = `Los días <strong>${listaAnteriores.join(', ')}</strong> y <strong>${ultimo}</strong> no van a tener operación en clínica`;
          }
        }

        this.$swal({
          icon: 'warning',
          title: 'Confirmar cambios',
          html: mensaje,
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#0046A2',
          cancelButtonColor: '#6c757d',
          focusCancel: false,
          returnFocus: false,
          customClass: {
            confirmButton: 'btn btn-secondary rounded-pill',
            cancelButton: 'btn btn-secondary rounded-pill'
          }
        }).then((result) => {
          resolve(result.isConfirmed);
        }).catch(() => {
          resolve(false);
        });
      });
    },
  }
}
</script>

<style scoped>
/* Estilos del Modal */
.titulo-modal { color: #0046A2; font-size: 20px; font-weight: bold; }
.subtitulo-modal { font-size: 17px; font-weight: 600; }

/* Centrado y estilo de Timepicker */
::v-deep .vue-timepicker input.display-time {
  text-align: center;
  height: 32px;
  border-radius: 6px;
  color: #008FFF;
  font-weight: 600;
}

::v-deep .vue-timepicker input.display-time:disabled {
  background-color: transparent;
  border-color: transparent;
  color: #adb5bd;
}

/* Convertir Radio Button en Cuadrado */
.radio-cuadrado {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #008FFF;
  border-radius: 2px;
  background-color: white;
  cursor: pointer;
  display: inline-grid;
  place-content: center;
  position: relative;
  top: 4px;
}

.radio-cuadrado::before {
  content: "";
  width: 10px;
  height: 10px;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em #008FFF;
  background-color: CanvasText;
}

.radio-cuadrado:checked::before {
  transform: scale(1);
}

/* Efecto visual para tabla desactivada */
.seccion-desactivada {
  opacity: 0.6;
  pointer-events: none;
  filter: grayscale(0.5);
}

/* Botón cerrar modal */
.btn-cerrar-modal {
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  transition: opacity 0.2s ease;
}

.btn-cerrar-modal:hover {
  opacity: 1;
}

.cerrar-icon {
  font-size: 28px;
  color: #212529;
  font-weight: 300;
  line-height: 1;
}

.checkbox-label { color: #008FFF; font-weight: 500; cursor: pointer; }

/* Botón Guardar */
.btn-guardar {
  background-color: #0046A2;
  border-color: #0046A2;
  padding: 8px 20px;
}

.btn-guardar:hover {
  background-color: #003880;
  border-color: #003880;
}

/* Modal */
::v-deep .modal-content {
  border-radius: 20px !important;
}
</style>